import { useState } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/daikn3boh653ivfvofbg';

type Status = 'idle' | 'loading' | 'success' | 'error';

export default function SubscribeForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [errorText, setErrorText] = useState('');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get('company_alt') || '').trim();
    if (honeypot) {
      setStatus('success');
      return;
    }

    const email = String(formData.get('email') || '').trim();
    if (!email) {
      setStatus('error');
      setErrorText('请先填写邮箱地址。');
      return;
    }

    const payload = new URLSearchParams();
    payload.append('email', email);

    setStatus('loading');
    setErrorText('');

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');
      const okCode = parsed?.code === 'OK';

      if (response.ok && okCode && !isSpam) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setErrorText(isSpam ? '提交被拦截，请稍后重试。' : serverMsg || '提交失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setErrorText('网络异常，请稍后重试。');
    }
  };

  return (
    <form
      data-readdy-form
      id="subscribe-form"
      onSubmit={handleSubmit}
      className="w-full"
      noValidate
    >
      <div className="flex flex-col sm:flex-row gap-3">
        <label htmlFor="subscribe-email" className="sr-only">邮箱地址</label>
        <input
          id="subscribe-email"
          type="email"
          name="email"
          autoComplete="email"
          placeholder="your@email.com"
          className="flex-1 rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 font-label"
        />
        <input
          type="text"
          name="company_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          className="subscribe-field-company_alt"
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-label text-background-50 hover:bg-accent-600 transition-colors whitespace-nowrap disabled:opacity-60 cursor-pointer"
        >
          {status === 'loading' ? (
            <>
              <i className="ri-loader-4-line animate-spin"></i>
              提交中
            </>
          ) : (
            <>
              <i className="ri-notification-3-line"></i>
              订阅提醒
            </>
          )}
        </button>
      </div>

      <div aria-live="polite" className="mt-3 min-h-[20px]">
        {status === 'success' && (
          <p className="text-sm font-label flex items-center gap-2 text-secondary-700">
            <i className="ri-checkbox-circle-line"></i>
            订阅成功，新清单发布时会第一时间提醒你。
          </p>
        )}
        {status === 'error' && (
          <p className="text-sm font-label flex items-center gap-2 text-accent-700">
            <i className="ri-error-warning-line"></i>
            {errorText}
          </p>
        )}
        {status === 'idle' && (
          <p className="text-xs text-foreground-500 font-label">
            我们只发送新的避雷清单，不发广告，随时可退订。
          </p>
        )}
      </div>
    </form>
  );
}